// VerifiedBadge: small indicator for verified/unverified plan data.

import React from 'react';
import { t } from '../lib/i18n';
import type { Lang } from '../lib/i18n';

interface VerifiedBadgeProps {
  verified: boolean;
  lang: Lang;
  inline?: boolean;
}

export function VerifiedBadge({ verified, lang, inline = false }: VerifiedBadgeProps) {
  if (inline) {
    return (
      <span
        className={`ml-1 text-xs ${verified ? 'text-emerald-600' : 'text-amber-600/60'}`}
        title={t(verified ? 'verified' : 'unverified', lang)}
      >
        {verified ? '✓' : '~'}
      </span>
    );
  }

  return (
    <span
      className={`inline-flex items-center gap-0.5 text-xs font-medium
        ${verified
          ? 'text-emerald-600'
          : 'text-amber-600/70'
        }`}
    >
      {verified ? (
        <>
          <svg className="w-3 h-3" viewBox="0 0 12 12" fill="none">
            <circle cx="6" cy="6" r="5" stroke="currentColor" strokeWidth="1" />
            <path d="M3.5 6l2 2 3-3" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          {t('verified', lang)}
        </>
      ) : (
        <>
          <svg className="w-3 h-3" viewBox="0 0 12 12" fill="none">
            <circle cx="6" cy="6" r="5" stroke="currentColor" strokeWidth="1" />
            <path d="M6 4v3M6 8.5v.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
          </svg>
          {t('unverified', lang)}
        </>
      )}
    </span>
  );
}
